const initial = () => ({ items: [], open_count: null, unread_count: 0, stale: false, applicable: false,
    verified_at: null, total: 0, page: 1, has_next: false, history: false, loaded: false, loading: false,
    error: "", epoch: 0, request: 0 });

export function createNotificationsModule() {
    let pending = null;
    return {
        namespaced: true,
        state: initial,
        mutations: {
            reset(state) { pending = null; Object.assign(state, initial(), { epoch: state.epoch + 1 }); },
            // A retry must not hide the warning/menu before availability is known.
            start(state, { page, history }) { state.loading = true; state.page = page; state.history = history; state.request++; },
            loaded(state, data) { Object.assign(state, data, { loaded: true, error: "" }); },
            failed(state, message) { state.error = message; state.stale = state.loaded; },
            finish(state) { state.loading = false; },
            seen(state, { items, data }) {
                const acknowledgements = new Map(items.map(i => [i.id, i.revision]));
                state.items = state.items.map(i => acknowledgements.get(i.id) >= i.revision ? { ...i, unread: false } : i);
                state.open_count = data.open_count; state.unread_count = data.unread_count;
            },
        },
        actions: {
            load({ state, commit }, { work, page = state.page, history = state.history } = {}) {
                if (pending && page === state.page && history === state.history) return pending;
                const epoch = state.epoch;
                commit("start", { page, history });
                const request = state.request;
                const task = work.get("/notifiche/", { page, history }, true).then(response => {
                    if (!response?.data || !Array.isArray(response.data.items) || !("open_count" in response.data)) throw new Error("Invalid notification response");
                    if (state.epoch === epoch && state.request === request) commit("loaded", response.data);
                }).catch(error => {
                    if (state.epoch === epoch && state.request === request) commit("failed", error?.response?.data?.detail || "Impossibile aggiornare le notifiche. Riprova.");
                }).finally(() => {
                    if (state.epoch === epoch && state.request === request) commit("finish");
                    if (pending === task) pending = null;
                });
                pending = task;
                return task;
            },
            async acknowledge({ state, commit }, { work, items }) {
                if (!items.length) return;
                const epoch = state.epoch, request = state.request;
                try {
                    const response = await work.post("/notifiche/", { items }, true);
                    if (!response?.data || !("unread_count" in response.data)) throw new Error("Invalid acknowledgement response");
                    if (state.epoch === epoch && state.request === request) commit("seen", { items, data: response.data });
                } catch (error) {
                    if (state.epoch === epoch) commit("failed", "Lettura non salvata. Riapri le notifiche per riprovare.");
                }
            },
        },
    };
}
